import { useRef, useEffect, useMemo } from 'react';
import { StoplightContainer, StoplightSquare } from './Stoplight.styled';

const COLORS = ['Green', 'Yellow', 'Red'];

const COLOR_TO_THEME_KEY = {
  Green: 'stoplightGreen',
  Yellow: 'stoplightYellow',
  Red: 'stoplightRed',
};

const getColorSlots = (activeValue, direction) => {
  const activeIdx = COLORS.indexOf(activeValue);
  if (activeIdx === -1) return { Green: 0, Yellow: 1, Red: 2 };

  const second =
    direction === 'backward'
      ? (activeIdx + 2) % 3
      : (activeIdx + 1) % 3;
  const third =
    direction === 'backward'
      ? (activeIdx + 1) % 3
      : (activeIdx + 2) % 3;

  const slots = {};
  slots[COLORS[activeIdx]] = 0;
  slots[COLORS[second]] = 1;
  slots[COLORS[third]] = 2;
  return slots;
};

const Stoplight = ({ value, size = 40 }) => {
  const prevValueRef = useRef(value);

  const direction = useMemo(() => {
    const prevIdx = COLORS.indexOf(prevValueRef.current);
    const currIdx = COLORS.indexOf(value);
    if (prevIdx === -1 || currIdx === -1 || prevIdx === currIdx) return 'none';
    const diff = (currIdx - prevIdx + 3) % 3;
    return diff === 1 ? 'forward' : 'backward';
  }, [value]);

  useEffect(() => {
    prevValueRef.current = value;
  }, [value]);

  const colorSlots = useMemo(
    () => getColorSlots(value, direction),
    [value, direction],
  );

  return (
    <StoplightContainer $size={size} aria-label={`Stoplight indicator: ${value}`}>
      {COLORS.map((color) => (
        <StoplightSquare
          key={color}
          $slot={colorSlots[color]}
          $color={COLOR_TO_THEME_KEY[color]}
          $size={size}
        />
      ))}
    </StoplightContainer>
  );
};

export default Stoplight;
